import {rgba} from "polished";
import {ReactElement, ReactNode} from "react";
import {styled} from "styled-components";

import {breakpoints} from "@/GlobalStyle";

const BlocStyled = styled.div<{$isDisabled: boolean}>`
  box-shadow: 0 0 6px 0 ${({theme}) => theme.colors.shadowBloc};
  padding: 10px 25px;
  width: calc(100% - 50px);
  margin: 20px 0;
  position: relative;
  background-color: ${({$isDisabled, theme}) =>
    $isDisabled ? rgba(theme.colors.grey, 0.2) : "white"};
  &:hover {
    cursor: ${({$isDisabled}) =>
      $isDisabled ? "not-allowed" : "pointer"} !important;
  }

  @media (max-width: ${breakpoints.md}) {
    padding: 15px;
    width: calc(100% - 30px);
  }
`;

export function BlocContent({
  children,
  className,
  isDisabled = false,
}: {
  children: ReactNode;
  className?: string;
  isDisabled?: boolean;
}): ReactElement {
  return (
    <BlocStyled
      className={className}
      data-testid="BlocStyled"
      $isDisabled={isDisabled}>
      {children}
    </BlocStyled>
  );
}
